
import { Api } from "@noom/noomscape";

import { Partner } from "@/models";

import axios from "axios";

type RequestParams = {
  slug: string;
};

Api.register("partner.getPartnerBySlug", async ({ slug }: RequestParams) => {
  const response = await axios({
    baseURL: window.ENV.SERVER_URL,
    method: "GET",
    params: {
      slug,
    },
    url: "/partners/v1/getBySlug",
    urlWithPathParams: "/partners/v1/getBySlug",
  });
  const partnerInfo: Partner = response.data;
  if (partnerInfo.goLiveDate) {
    partnerInfo.goLiveDate = new Date(partnerInfo.goLiveDate);
  }
  return partnerInfo;
});
